// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1FWFg","calendarButtons":"ClockData_calendarButtons__3qHxa"};